import { useEffect, useRef } from 'react'

const BUSINESS_ORIGIN = process.env.NEXT_BUSINESS_ORIGIN || 'https://combine-next.jarvisbro.com'

export function BusinessSessionBridge({ clear = false, onCompleted }: { clear?: boolean; onCompleted?: () => void }) {
  const frame = useRef<HTMLIFrameElement>(null)
  const completed = useRef(false)
  const send = () => frame.current?.contentWindow?.postMessage({
    type: 'next-business-session',
    token: clear ? '' : localStorage.getItem('business_web_token'),
    clear,
  }, BUSINESS_ORIGIN)

  useEffect(() => {
    const receive = (event: MessageEvent) => {
      if (event.origin !== BUSINESS_ORIGIN || event.source !== frame.current?.contentWindow) return
      if (event.data?.type === 'next-business-session-ready') send()
      if (event.data?.type === 'next-business-session-complete' && event.data.ok === true && !completed.current) {
        completed.current = true
        onCompleted?.()
      }
    }
    window.addEventListener('message', receive)
    return () => window.removeEventListener('message', receive)
  }, [clear, onCompleted])

  return <iframe ref={frame} title={clear ? 'AILogout' : 'AILogin'}
    src={`${BUSINESS_ORIGIN}/next-session.html`} onLoad={send}
    sandbox="allow-scripts allow-same-origin" aria-hidden="true" tabIndex={-1}
    style={{ position: 'absolute', left: -10000, width: 1, height: 1, border: 0 }} />
}

export default function BusinessLogin() { return <BusinessSessionBridge /> }
